import React from 'react';

import {ModalPane} from 'constants/SampleConstants';
import {BoxSchema} from 'samples/storables/StorableSchemaConstants';
import * as TagUtil from 'schemas/tags/TagUtil';

import BaseStorablePane, {
  BaseStorablePaneProps,
  CreateStorablePaneState,
  DEFAULT_CREATE_STORABLE_STATE,
} from './BaseStorablePane';
import BaseStorablePaneStudyableFormGroup, {
  BaseStorablePaneStudyableState,
  BaseStorablePaneStudyableProps,
} from './BaseStorablePaneStudyableFormGroup';
import BoxSchemaSelector from './BoxSchemaSelector';

export interface CreateBoxPaneProps
  extends Omit<BaseStorablePaneProps, 'nameLabel' | 'modalPane' | 'schemaSelector'>,
    BaseStorablePaneStudyableProps {
  selectedSchema?: BoxSchema | null;
}

export interface CreateBoxPaneState extends CreateStorablePaneState, BaseStorablePaneStudyableState {
  isValidating: boolean;
  selectedSchema: BoxSchema | null;
}

export const DEFAULT_CREATE_BOX_PANE_STATE: CreateBoxPaneState = {
  ...DEFAULT_CREATE_STORABLE_STATE,
  selectedSchema: null,
  isValidating: false,
};

class CreateBoxPane extends React.Component<CreateBoxPaneProps> {
  _handleChangeBoxSchema = (boxSchema: BoxSchema): void => {
    this.props.onUpdate({
      selectedSchema: boxSchema,
      tags: TagUtil.getInitialTags(boxSchema.fields),
    });
  };

  _renderSchemaSelector = (): JSX.Element => (
    <BoxSchemaSelector
      error={this.props.validationErrors.schemaError}
      onChange={this._handleChangeBoxSchema}
      registryId={this.props.registryId}
      selectedBoxSchemaId={this.props.selectedSchema ? this.props.selectedSchema.id : null}
    />
  );

  render(): JSX.Element {
    return (
      <BaseStorablePane
        nameLabel="Box name"
        modalPane={ModalPane.CREATE_BOX}
        schemaSelector={this._renderSchemaSelector()}
        {...this.props}
      >
        <BaseStorablePaneStudyableFormGroup
          studySearchInputProps={this.props.studySearchInputProps}
          studyIds={this.props.studyIds}
          onUpdate={this.props.onUpdate}
        />
      </BaseStorablePane>
    );
  }
}

export default CreateBoxPane;
